import { AppRootState } from 'app/store'
import { dashboardReducer } from 'features/dashboard'

export const loadState: Function = (): AppRootState | undefined => {
  try {
    const savedState = localStorage.getItem('state')

    if (savedState === null) {
      return undefined
    }

    return JSON.parse(savedState) as AppRootState
  } catch (e) {
    return undefined
  }
}

export const saveState = (state: { dashboard: ReturnType<typeof dashboardReducer> }) => {
  try {
    const stateToBeSaved = JSON.stringify(state)

    localStorage.setItem('state', stateToBeSaved)
  } catch (e) {
    console.error(e)
  }
}
